import { supabase } from "@/lib/supabase";

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function buildWhatsAppLink(number?: string | number | null, message?: string): string {
  const clean = String(number ?? "").replace(/\D/g, "");
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${clean}?text=${text}`;
}

export async function logActivity(accion: string, elemento?: string) {
  try {
    const { data } = await supabase.auth.getUser();
    const usuario =
      data?.user?.user_metadata?.name || data?.user?.email || "Administrador";
    await supabase.from("activity_logs").insert({
      usuario,
      accion,
      elemento: elemento ?? null,
    });
  } catch {
    // el historial no debe bloquear la operación principal
  }
}

export function formatBytes(bytes?: number | null): string {
  if (!bytes || bytes <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function formatDate(dateStr?: string | null): string {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(dateStr?: string | null): string {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export async function getSettings(): Promise<Record<string, string | number | boolean>> {
  const { data } = await supabase.from("site_settings").select("key, value");
  const map: Record<string, string | number | boolean> = {};
  (data ?? []).forEach((r) => {
    map[r.key] = r.value as string | number | boolean;
  });
  return map;
}

export async function saveSetting(key: string, value: unknown) {
  const { data } = await supabase
    .from("site_settings")
    .select("id")
    .eq("key", key)
    .maybeSingle();
  if (data) {
    await supabase.from("site_settings").update({ value }).eq("id", data.id);
  } else {
    await supabase.from("site_settings").insert({ key, value });
  }
}